import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, styled, tableCellClasses } from "@mui/material";
import Swot from "../types/negocio/Swot";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'inherit', 
        color: 'inherit',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

interface SwotTableProps {
    rows: Swot[]
    title: string
    color: 'primary' | 'secondary'
}

const SwotTable: React.FC<SwotTableProps> = ({ rows, title, color }) => {
    return (
        <Paper elevation={3} sx={{ 
            width: '100%',
            overflow: 'hidden',
        }}>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableHead sx={{ 
                        backgroundColor: (theme) => theme.palette[color].main,
                        color: (theme) => theme.palette[color].contrastText
                    }}>
                        <TableRow>
                            <StyledTableCell><strong>{title}</strong></StyledTableCell>
                            <StyledTableCell align="center" sx={{ width: '5%' }}><strong>Pontuação</strong></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell component="th" scope="row">
                                    <Typography variant="body2">
                                        {row.descricao}
                                    </Typography>
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                    <Typography variant="body2">
                                        {row.pontuacao}
                                    </Typography>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default SwotTable;